const storeOrders = (state = {}, action) => {
  switch (action.type) {
    case "SET_STORE_ORDER":
      return action.payload;
    default:
      return state;
  }
};

export default storeOrders;
